meedy.controller('meedy.popupNewUserController', ['$scope', '$state', '$mdDialog',
    function ($scope, $state, $mdDialog) {

        function setData() {
        }

        function setPermissions() {
        }

        function setListeners() {

        }

        function setActions() {
            $scope.ok = function() {
                $mdDialog.hide();
            };

            $scope.cancel = function() {
                $mdDialog.cancel();
            };

        }

        function configureInterface() {

        }

        function initialize() {

        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);